/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _circle12, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _circle13, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _circle14, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _circle15, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _circle16, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _switch, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359;
const Purchase = /*#__PURE__*/React.forwardRef(function Purchase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H16V22H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Purchase.propTypes = iconPropTypes;
}
const WatsonHealthQcLaunch = /*#__PURE__*/React.forwardRef(function WatsonHealthQcLaunch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25,22H19a2.0023,2.0023,0,0,1-2-2V10a2.002,2.002,0,0,1,2-2h6v2H19V20h6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13,8H9a2.002,2.002,0,0,0-2,2V20a2.0023,2.0023,0,0,0,2,2h1v2a2.0023,2.0023,0,0,0,2,2h2V24H12V22h1a2.0023,2.0023,0,0,0,2-2V10A2.002,2.002,0,0,0,13,8ZM9,20V10h4V20Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthQcLaunch.propTypes = iconPropTypes;
}
const Qiskit = /*#__PURE__*/React.forwardRef(function Qiskit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,1C7.729,1,1,7.729,1,16s6.729,15,15,15,15-6.729,15-15S24.271,1,16,1Zm6.5825,20.5c-.5203-.8926-1.4771-1.5-2.5825-1.5-.1821,0-.3586.0225-.532.0537l-1.7258-3.0205c6.7866.2388,10.1216,1.8262,10.2571,2.4668-.0979.4624-1.8899,1.4141-5.4167,2Zm-2.5825.5c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1ZM3,16c0-.5435.0442-1.0762.1094-1.6025.8552.666,2.1555,1.1973,3.7239,1.6025-1.5684.4053-2.8687.9365-3.7239,1.6025-.0652-.5264-.1094-1.0591-.1094-1.6025Zm6.4175-5.4995c.5205.8921,1.4773,1.4995,2.5825,1.4995.1821,0,.3586-.0225.532-.0537l1.7258,3.0205c-6.8042-.2393-10.1387-1.8335-10.2581-2.4619.0862-.4609,1.8784-1.416,5.4177-2.0044Zm2.5825-.5005c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm13.167,6c1.5681-.4053,2.8684-.9365,3.7236-1.6025.0652.5264.1094,1.0591.1094,1.6025s-.0442,1.0762-.1094,1.6025c-.8552-.666-2.1555-1.1973-3.7236-1.6025ZM16,3c4.9019,0,9.1758,2.7285,11.3901,6.7451-2.2891-.9961-5.7993-1.5513-9.3901-1.6997v1.999c6.6108.2695,9.8655,1.8232,9.9993,2.4556-.1431.6763-3.8533,2.4062-11.4236,2.4917l-2.3118-4.0454c.4524-.5254.7361-1.2002.7361-1.9463,0-1.6543-1.3457-3-3-3-1.4956,0-2.7285,1.1035-2.9531,2.5371-1.7056.2837-3.2363.6841-4.4351,1.2051,2.2151-4.0146,6.4878-6.7422,11.3882-6.7422Zm0,26c-4.9019,0-9.1758-2.7285-11.3901-6.7451,2.2891.9961,5.7993,1.5513,9.3901,1.6997v-1.999c-6.6282-.2705-9.8823-1.8306-10.0002-2.4507.126-.6729,3.8357-2.4106,11.4246-2.4966l2.3118,4.0454c-.4524.5254-.7361,1.2002-.7361,1.9463,0,1.6543,1.3457,3,3,3,1.4956,0,2.7285-1.1035,2.9531-2.5371,1.7056-.2837,3.2363-.6841,4.4351-1.2051-2.2151,4.0146-6.4878,6.7422-11.3882,6.7422Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Qiskit.propTypes = iconPropTypes;
}
const QqPlot = /*#__PURE__*/React.forwardRef(function QqPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QqPlot.propTypes = iconPropTypes;
}
const QrCode = /*#__PURE__*/React.forwardRef(function QrCode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20L26 18 30 18 30 22 28 22 28 20 26 20z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30H2V18H14ZM4,28h8V20H4Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V10H22z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H18V2H30ZM20,12h8V4H20Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QrCode.propTypes = iconPropTypes;
}
const QuadrantPlot = /*#__PURE__*/React.forwardRef(function QuadrantPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,5,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,5,26Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,8,8ZM8,4A1,1,0,1,0,9,5,1.001,1.001,0,0,0,8,4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,22,13Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,22,9Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QuadrantPlot.propTypes = iconPropTypes;
}
const Query = /*#__PURE__*/React.forwardRef(function Query({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Query.propTypes = iconPropTypes;
}
const QueryQueue = /*#__PURE__*/React.forwardRef(function QueryQueue({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H28V14H10z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H28V20H15z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H28V26H10z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14L11 19 4 24 4 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QueryQueue.propTypes = iconPropTypes;
}
const QuestionAnswering = /*#__PURE__*/React.forwardRef(function QuestionAnswering({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M20 15.1798L17.41 12.59 16 14 20 18 26 12 24.59 10.59 20 15.1798z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8 18H10V20H8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,9h-5v2h4v2h-3v3h2v-1h2c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.7358,30l-1.7358-1,4-7h6c1.1071,0,2-.8926,2-2v-12c0-1.1074-.8929-2-2-2H6c-1.1071,0-2,.8926-2,2v12c0,1.1074.8929,2,2,2h9v2H6c-2.2093,0-4-1.79-4-4v-12c0-2.2109,1.7907-4,4-4h20c2.2093,0,4,1.7891,4,4v12c0,2.21-1.7907,4-4,4h-4.8354l-3.4287,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QuestionAnswering.propTypes = iconPropTypes;
}
const Queued = /*#__PURE__*/React.forwardRef(function Queued({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H30V22H22z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H30V26H22z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H30V30H22z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H20V26H18z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H20V22H18z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H20V30H18z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8149,8.293A12.0777,12.0777,0,0,1,10.0068,5.62L9.0079,3.89A14.0845,14.0845,0,0,0,5.2841,7.0083Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1851,8.293l1.5308-1.2847A14.0845,14.0845,0,0,0,22.9921,3.89l-.9989,1.73A12.0777,12.0777,0,0,1,25.1851,8.293Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7366,11.9l-1.8772-.6831A13.9019,13.9019,0,0,0,2,16H4A11.917,11.917,0,0,1,4.7366,11.9Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8149,23.707A11.9975,11.9975,0,0,1,4.7366,20.1l-1.8772.6831a13.99,13.99,0,0,0,2.4247,4.209Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2634,11.9A11.917,11.917,0,0,1,28,16h2a13.8971,13.8971,0,0,0-.8594-4.7827Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9182,27.8066A11.8894,11.8894,0,0,1,10.0068,26.38l-.9989,1.73a13.8673,13.8673,0,0,0,4.5633,1.664Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9182,4.1934a11.3012,11.3012,0,0,1,4.1636,0l.347-1.9678a13.187,13.187,0,0,0-4.8576,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Queued.propTypes = iconPropTypes;
}
const Quotes = /*#__PURE__*/React.forwardRef(function Quotes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15H6.11A9,9,0,0,1,10,8.86l1.79-1.2L10.69,6,8.9,7.2A11,11,0,0,0,4,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,12,15Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15H20.11A9,9,0,0,1,24,8.86l1.79-1.2L24.7,6,22.9,7.2A11,11,0,0,0,18,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,26,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Quotes.propTypes = iconPropTypes;
}
const Radar = /*#__PURE__*/React.forwardRef(function Radar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Radar.propTypes = iconPropTypes;
}
const RadarEnhanced = /*#__PURE__*/React.forwardRef(function RadarEnhanced({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RadarEnhanced.propTypes = iconPropTypes;
}
const RadarWeather = /*#__PURE__*/React.forwardRef(function RadarWeather({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RadarWeather.propTypes = iconPropTypes;
}
const Radio = /*#__PURE__*/React.forwardRef(function Radio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26a4,4,0,1,1,4-4A4,4,0,0,1,10,26Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,20Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14H13V16H7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16H26V18H17z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H26V22H17z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H26V26H17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Radio.propTypes = iconPropTypes;
}
const RadioCombat = /*#__PURE__*/React.forwardRef(function RadioCombat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,20Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H26V22H17z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H26V26H17z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RadioCombat.propTypes = iconPropTypes;
}
const RadioPushToTalk = /*#__PURE__*/React.forwardRef(function RadioPushToTalk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H19V13H13z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H19V17H13z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RadioPushToTalk.propTypes = iconPropTypes;
}
const RadioButton = /*#__PURE__*/React.forwardRef(function RadioButton({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RadioButton.propTypes = iconPropTypes;
}
const RadioButtonChecked = /*#__PURE__*/React.forwardRef(function RadioButtonChecked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RadioButtonChecked.propTypes = iconPropTypes;
}
const Rag = /*#__PURE__*/React.forwardRef(function Rag({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,28h-2c-3.8599,0-7-3.1401-7-7v-2h2v2c0,2.7568,2.2432,5,5,5h2v2Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,19h-9c-1.104.0014-1.9986.896-2,2v5c0,1.1046.8954,2,2,2h3v-2h-3v-5h9v5h-2.5352l-2.5937,3.8906,1.6641,1.1094,2-3h1.4648c1.1046,0,2-.8954,2-2v-5c-.0014-1.104-.896-1.9986-2-2Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,15v-4c0-3.8599-3.1401-7-7-7h-3v2h3c2.7568,0,5,2.2432,5,5v4h2Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 10H9V12H6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12.606,6.4355l-2.5251-3.6855c-.3821-.4766-.9512-.75-1.5615-.75h-4.5193c-1.1028,0-2,.8975-2,2v10c0,1.1025.8972,2,2,2h7c1.1028,0,2-.8975,2-2v-6.375c0-.4526-.1558-.8965-.394-1.1895Zm-8.606,7.5645V4h4v3c0,.5522.4478,1,1,1h2v6h-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rag.propTypes = iconPropTypes;
}
const Rain = /*#__PURE__*/React.forwardRef(function Rain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22ZM16,4a7,7,0,0,0-6.94,6.14L9,11,8.14,11a4.5,4.5,0,0,0,.36,9h15a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82A7,7,0,0,0,16,4Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,14,30Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,20,30Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,8,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rain.propTypes = iconPropTypes;
}
const RainDrizzle = /*#__PURE__*/React.forwardRef(function RainDrizzle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RainDrizzle.propTypes = iconPropTypes;
}
const RainHeavy = /*#__PURE__*/React.forwardRef(function RainHeavy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,17,30Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,8,30Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RainHeavy.propTypes = iconPropTypes;
}
const RainScattered = /*#__PURE__*/React.forwardRef(function RainScattered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M27.232 15.733H29.232V18.733H27.232z",
    transform: "rotate(-45.009 28.232 17.233)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M12.768 3.268H14.768V6.268H12.768z",
    transform: "rotate(-45 13.768 4.768)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RainScattered.propTypes = iconPropTypes;
}
const RainScatteredNight = /*#__PURE__*/React.forwardRef(function RainScatteredNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0115,1.0115,0,0,1-.4485-.1055.9986.9986,0,0,1-.4486-1.3418l1.4934-3a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0015,1.0015,0,0,1,8.5084,32Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8442,13.0347a1.5184,1.5184,0,0,0-1.2309-.8658,5.3587,5.3587,0,0,1-3.4094-1.7163,6.4648,6.4648,0,0,1-1.285-6.393,1.6031,1.6031,0,0,0-.3-1.5459,1.4535,1.4535,0,0,0-1.3594-.4922l-.0191.0029a7.8549,7.8549,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9549,5.9549,0,0,0,5.88-7.1455,7.5,7.5,0,0,0,4.8672-3.3A1.5381,1.5381,0,0,0,29.8442,13.0347ZM19,23H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm5.1509-7.0479a5.9639,5.9639,0,0,0-3.5015-2.708A7.5076,7.5076,0,0,0,18.0286,9.55a6.01,6.01,0,0,1,3.77-5.334,8.4581,8.4581,0,0,0,1.9395,7.5972A7.4007,7.4007,0,0,0,27.64,14.041,5.4392,5.4392,0,0,1,24.1509,15.9521Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RainScatteredNight.propTypes = iconPropTypes;
}
const RainDrop = /*#__PURE__*/React.forwardRef(function RainDrop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RainDrop.propTypes = iconPropTypes;
}
const Raw = /*#__PURE__*/React.forwardRef(function Raw({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V23h2V18h4v5h2V11A2,2,0,0,0,18,9Zm-4,7V11h4v5Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M10,15V11A2,2,0,0,0,8,9H2V23H4V17H5.48l2.34,6H10L7.63,17H8A2,2,0,0,0,10,15ZM4,11H8v4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Raw.propTypes = iconPropTypes;
}
const Receipt = /*#__PURE__*/React.forwardRef(function Receipt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H23V18H21z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H17V18H9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H23V14H21z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H17V14H9z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H23V10H9z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Receipt.propTypes = iconPropTypes;
}
const RecentlyViewed = /*#__PURE__*/React.forwardRef(function RecentlyViewed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RecentlyViewed.propTypes = iconPropTypes;
}
const Recommend = /*#__PURE__*/React.forwardRef(function Recommend({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Recommend.propTypes = iconPropTypes;
}
const Recording = /*#__PURE__*/React.forwardRef(function Recording({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Recording.propTypes = iconPropTypes;
}
const RecordingFilled = /*#__PURE__*/React.forwardRef(function RecordingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RecordingFilled.propTypes = iconPropTypes;
}
const RecordingFilledAlt = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22 z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RecordingFilledAlt.propTypes = iconPropTypes;
}
const Recycle = /*#__PURE__*/React.forwardRef(function Recycle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5081,22.2549l-2.0781-3.7402-1.7485,.9707,2.0781,3.7412c.3247,.584,.3162,1.2769-.0229,1.8535-.3391,.5762-.9407,.9199-1.6091,.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5,5,5,5,1.4102-1.4102-2.5801-2.5898h7.2974c1.3848,0,2.6306-.7124,3.3328-1.9058,.7024-1.1938,.7202-2.6284,.0479-3.8394Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8726,26c-.6685,0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004,1.0479,3.52,1.9121-.5664-2.0083-6.7798-6.7798,2.0083,.5664,1.9121,3.4934-1.0298-4.0913,7.3643c-.6724,1.2109-.6545,2.6455,.0479,3.8394,.7021,1.1934,1.948,1.9058,3.3328,1.9058h6.1274v-2H5.8726Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M25.51,9.6538l-1.0476,3.519L19.3503,3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646,.7368-3.3503,1.9712l-3.0796,5.5435,1.7485,.9707,3.0796-5.543c.3276-.5898,.9265-.9424,1.6018-.9424s1.2742,.3525,1.6018,.9424l5.0925,9.167-3.4939-1.0298-.5664,1.9121,6.78,2.0083,2.0083-6.7798-1.9124-.5664Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Recycle.propTypes = iconPropTypes;
}
const Redefinition = /*#__PURE__*/React.forwardRef(function Redefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M13,28v-4h7v-2h-7v-4h7c.3564,0,.686-.1899.865-.498.179-.3086.1802-.6885.0032-.998L12.8682,2.5039c-.356-.623-1.3804-.623-1.7363,0L3.1318,16.5039c-.177.3096-.1758.6895.0032.998.179.3081.5085.498.865.498h7v4h-7v2h7v4c0,1.1045.8955,2,2,2h15v-2h-15ZM5.7231,16l6.2769-10.9844,6.2769,10.9844H5.7231Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Redefinition.propTypes = iconPropTypes;
}
const Redo = /*#__PURE__*/React.forwardRef(function Redo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Redo.propTypes = iconPropTypes;
}
const RefEvapotranspiration = /*#__PURE__*/React.forwardRef(function RefEvapotranspiration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M14,12a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L13.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L17.3154,6.11A3.9693,3.9693,0,0,1,18,8.223,3.8978,3.8978,0,0,1,14,12Zm.0005-7.2368L12.3438,7.2257A1.89,1.89,0,0,0,12,8.223,1.9,1.9,0,0,0,14,10a1.9,1.9,0,0,0,2-1.777,1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,26A5.385,5.385,0,0,1,2,20.751,5.3837,5.3837,0,0,1,2.874,17.92L6.49,12.5383a1.2168,1.2168,0,0,1,2.02-.0006l3.55,5.2777A5.4923,5.4923,0,0,1,13,20.751,5.385,5.385,0,0,1,7.5,26Zm0-11.38L4.5649,18.9868A3.3586,3.3586,0,0,0,4,20.751,3.3855,3.3855,0,0,0,7.5,24,3.3855,3.3855,0,0,0,11,20.751a3.4354,3.4354,0,0,0-.63-1.867Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,20,7l1.4141,1.4141L24,5.8281V16a4.0045,4.0045,0,0,1-4,4H16v2h4a6.0066,6.0066,0,0,0,6-6V5.8281l2.5859,2.586L30,7Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RefEvapotranspiration.propTypes = iconPropTypes;
}
const ReferenceArchitecture = /*#__PURE__*/React.forwardRef(function ReferenceArchitecture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m28,20c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2h-1v-5c0-1.1025-.8972-2-2-2h-5v-1c0-1.1025-.8972-2-2-2h-4c-1.1028,0-2,.8975-2,2v1h-5c-1.1028,0-2,.8975-2,2v5.1421c-1.7202.4473-3,1.9995-3,3.8579s1.2798,3.4106,3,3.8579v5.1421c0,1.1025.8972,2,2,2h7v1c0,1.1025.8972,2,2,2h12c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2h-1v-2h1Zm0-2h-4v-4h4v4ZM14,4h4v4h-4v-4Zm-2,3v1c0,1.1025.8972,2,2,2h4c1.1028,0,2-.8975,2-2v-1h5v5h-1c-1.1028,0-2,.8975-2,2v1h-12.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-5.1421h5Zm-8,9c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Zm24,12h-12v-4h12v4Zm-3-6h-9c-1.1028,0-2,.8975-2,2v1h-7v-5.1421c1.3987-.3638,2.4941-1.459,2.8579-2.8579h12.1421v1c0,1.1025.8972,2,2,2h1v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ReferenceArchitecture.propTypes = iconPropTypes;
}
const ReflectHorizontal = /*#__PURE__*/React.forwardRef(function ReflectHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-180 16 16)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ReflectHorizontal.propTypes = iconPropTypes;
}
const ReflectVertical = /*#__PURE__*/React.forwardRef(function ReflectVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-90 16 16)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ReflectVertical.propTypes = iconPropTypes;
}
const WatsonHealthRegionAnalysisArea = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthRegionAnalysisArea.propTypes = iconPropTypes;
}
const WatsonHealthRegionAnalysisVolume = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthRegionAnalysisVolume.propTypes = iconPropTypes;
}
const WatsonHealthRegistration = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28,25H20a2.0027,2.0027,0,0,1-2-2V20h2v3h8V9H20v3H18V9a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2V23A2.0027,2.0027,0,0,1,28,25Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H12V17H8z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H24V17H20z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H18V17H14z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M12,25H4a2.0023,2.0023,0,0,1-2-2V9A2.002,2.002,0,0,1,4,7h8a2.002,2.002,0,0,1,2,2v3H12V9H4V23h8V20h2v3A2.0023,2.0023,0,0,1,12,25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthRegistration.propTypes = iconPropTypes;
}
const Reminder = /*#__PURE__*/React.forwardRef(function Reminder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Reminder.propTypes = iconPropTypes;
}
const ReminderMedical = /*#__PURE__*/React.forwardRef(function ReminderMedical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ReminderMedical.propTypes = iconPropTypes;
}
const Renew = /*#__PURE__*/React.forwardRef(function Renew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H6.78A11,11,0,0,1,27,16h2A13,13,0,0,0,6,7.68V4H4v8h8Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22h5.22A11,11,0,0,1,5,16H3a13,13,0,0,0,23,8.32V28h2V20H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Renew.propTypes = iconPropTypes;
}
const Repeat = /*#__PURE__*/React.forwardRef(function Repeat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26.1719l-3.586-3.5859L24,1l6,6-6,6-1.4141-1.4141L26.1719,8H6v7H4V8A2.0024,2.0024,0,0,1,6,6Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4141,20.4141,5.8281,24H26V17h2v7a2.0024,2.0024,0,0,1-2,2H5.8281L9.414,29.5859,8,31,2,25l6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Repeat.propTypes = iconPropTypes;
}
const RepeatOne = /*#__PURE__*/React.forwardRef(function RepeatOne({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26.1719l-3.586-3.5859L24,1l6,6-6,6-1.4141-1.4141L26.1719,8H6v7H4V8A2.0024,2.0024,0,0,1,6,6Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4141,20.4141,5.8281,24H26V17h2v7a2.0024,2.0024,0,0,1-2,2H5.8281L9.414,29.5859,8,31,2,25l6-6Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RepeatOne.propTypes = iconPropTypes;
}
const Replicate = /*#__PURE__*/React.forwardRef(function Replicate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8h2V4a2.0021,2.0021,0,0,0-2-2H24V4h4Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H21V4H17z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11H30V15H28z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v4H24V10a2.0023,2.0023,0,0,0-2-2H10V4h4V2H10A2.0023,2.0023,0,0,0,8,4V8H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24h4a2.0023,2.0023,0,0,0,2-2V18ZM22,28H4V10H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Replicate.propTypes = iconPropTypes;
}
const Reply = /*#__PURE__*/React.forwardRef(function Reply({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Reply.propTypes = iconPropTypes;
}
const ReplyAll = /*#__PURE__*/React.forwardRef(function ReplyAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ReplyAll.propTypes = iconPropTypes;
}
const RepoArtifact = /*#__PURE__*/React.forwardRef(function RepoArtifact({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5 C30,8.9,29.1,8,28,8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RepoArtifact.propTypes = iconPropTypes;
}
const RepoSourceCode = /*#__PURE__*/React.forwardRef(function RepoSourceCode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8 C30,8.9,29.1,8,28,8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RepoSourceCode.propTypes = iconPropTypes;
}
const Report = /*#__PURE__*/React.forwardRef(function Report({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H18V20H10z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H22V15H10z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H15V25H10z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Report.propTypes = iconPropTypes;
}
const ReportData = /*#__PURE__*/React.forwardRef(function ReportData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V24H20z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H12V24H10z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ReportData.propTypes = iconPropTypes;
}
const RequestQuote = /*#__PURE__*/React.forwardRef(function RequestQuote({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RequestQuote.propTypes = iconPropTypes;
}
const RequirementDefinition = /*#__PURE__*/React.forwardRef(function RequirementDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.1788,17.4959c0-2.8367,1.5301-4.6764,4.1606-4.6764,2.8025,0,4.0919,2.0631,4.0919,4.5217v.7221h-5.9658v.2235c0,1.2894.7392,2.1663,2.1834,2.1663,1.0833,0,1.7365-.5158,2.2867-1.2207l1.1863,1.3239c-.7392,1.0143-2.0459,1.6505-3.7137,1.6505-2.6475,0-4.2293-1.8397-4.2293-4.7109Zm2.2867-.9284v.1377h3.6791v-.1548c0-1.2379-.6362-2.0803-1.7709-2.0803-1.152,0-1.9083.8597-1.9083,2.0975Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.2694,22h-2.2693v-12h5.4154c2.1835,0,3.5416,1.4441,3.5416,3.7135,0,1.6504-.7565,2.9054-2.2349,3.4039l2.4584,4.8826h-2.5271l-2.2349-4.6247h-2.1492v4.6247Zm3.1215-6.533c.8769,0,1.4097-.4813,1.4097-1.3581v-.7909c0-.8769-.5328-1.341-1.4097-1.341h-2.9227v3.4899h2.9227Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RequirementDefinition.propTypes = iconPropTypes;
}
const RequirementUsage = /*#__PURE__*/React.forwardRef(function RequirementUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.1788,17.4959c0-2.8367,1.5301-4.6764,4.1606-4.6764,2.8025,0,4.0919,2.0631,4.0919,4.5217v.7221h-5.9658v.2235c0,1.2894.7392,2.1663,2.1834,2.1663,1.0833,0,1.7365-.5158,2.2867-1.2207l1.1863,1.3239c-.7392,1.0143-2.0459,1.6505-3.7137,1.6505-2.6475,0-4.2293-1.8397-4.2293-4.7109Zm2.2867-.9284v.1377h3.6791v-.1548c0-1.2379-.6362-2.0803-1.7709-2.0803-1.152,0-1.9083.8597-1.9083,2.0975Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.2694,22h-2.2693v-12h5.4154c2.1835,0,3.5416,1.4441,3.5416,3.7135,0,1.6504-.7565,2.9054-2.2349,3.4039l2.4584,4.8826h-2.5271l-2.2349-4.6247h-2.1492v4.6247Zm3.1215-6.533c.8769,0,1.4097-.4813,1.4097-1.3581v-.7909c0-.8769-.5328-1.341-1.4097-1.341h-2.9227v3.4899h2.9227Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RequirementUsage.propTypes = iconPropTypes;
}
const Reset = /*#__PURE__*/React.forwardRef(function Reset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Reset.propTypes = iconPropTypes;
}
const ResetAlt = /*#__PURE__*/React.forwardRef(function ResetAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ResetAlt.propTypes = iconPropTypes;
}
const Restart = /*#__PURE__*/React.forwardRef(function Restart({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
      d: "M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6 s6-2.7,6-6H13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Restart.propTypes = iconPropTypes;
}
const Restaurant = /*#__PURE__*/React.forwardRef(function Restaurant({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H11V12H9z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11a4,4,0,0,1-8,0V2H4v9a6,6,0,0,0,5,5.91V30h2V16.91A6,6,0,0,0,16,11V2H14Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2H21V30h2V20h3a2,2,0,0,0,2-2V8A5.78,5.78,0,0,0,22,2Zm4,16H23V4.09c2.88.56,3,3.54,3,3.91Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Restaurant.propTypes = iconPropTypes;
}
const RestaurantFine = /*#__PURE__*/React.forwardRef(function RestaurantFine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11.0005v-8a1,1,0,0,0-1-1H19a1,1,0,0,0-1,1v8A6.0039,6.0039,0,0,0,23,16.91V28H19v2H29V28H25V16.91A6.0039,6.0039,0,0,0,30,11.0005Zm-10,0V4h8v7.0005a4,4,0,1,1-8,0Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M12,2v9.02a3.9644,3.9644,0,0,1-3.96,3.96A4.0052,4.0052,0,0,1,4,11.02V2H2v9.02a5.9888,5.9888,0,0,0,5,5.8652V30H9V16.8953A5.9646,5.9646,0,0,0,14,11.02V2Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H9V11.98H7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RestaurantFine.propTypes = iconPropTypes;
}
const Result = /*#__PURE__*/React.forwardRef(function Result({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H22V25H14z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H22V20H14z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Result.propTypes = iconPropTypes;
}
const ResultDraft = /*#__PURE__*/React.forwardRef(function ResultDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7,19.3l-3-3c-0.4-0.4-1-0.4-1.4,0L16,25.6V30h4.4l9.3-9.3C30.1,20.3,30.1,19.7,29.7,19.3z M19.6,28H18v-1.6l5-5l1.6,1.6 L19.6,28z M26,21.6L24.4,20l1.6-1.6l1.6,1.6L26,21.6z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V20H14z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28V7h3v3h12V7h3v6h2V7c0-1.1-0.9-2-2-2h-3V4c0-1.1-0.9-2-2-2h-8c-1.1,0-2,0.9-2,2v1H7C5.9,5,5,5.9,5,7v21 c0,1.1,0.9,2,2,2h5v-2H7z M12,4h8v4h-8V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ResultDraft.propTypes = iconPropTypes;
}
const ResultNew = /*#__PURE__*/React.forwardRef(function ResultNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "26",
    r: "4"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H22V20H14z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H18V25H14z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ResultNew.propTypes = iconPropTypes;
}
const ResultOld = /*#__PURE__*/React.forwardRef(function ResultOld({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ResultOld.propTypes = iconPropTypes;
}
const RetryFailed = /*#__PURE__*/React.forwardRef(function RetryFailed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M18,2A12.0351,12.0351,0,0,0,6,14v6.2L2.4,16.6,1,18l6,6,6-6-1.4-1.4L8,20.2V14a10,10,0,0,1,20,0v3h2V14A12.0351,12.0351,0,0,0,18,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RetryFailed.propTypes = iconPropTypes;
}
const Return = /*#__PURE__*/React.forwardRef(function Return({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m22,8v2c2.2061,0,4,1.7944,4,4s-1.7939,4-4,4h-12v-5l-6,6,6,6v-5h12c3.3086,0,6-2.6914,6-6s-2.6914-6-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Return.propTypes = iconPropTypes;
}
const Review = /*#__PURE__*/React.forwardRef(function Review({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Review.propTypes = iconPropTypes;
}
const Rewind_10 = /*#__PURE__*/React.forwardRef(function Rewind_10({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,22.13a2.84,2.84,0,0,1-1.28-.27,2.44,2.44,0,0,1-.89-.77,3.57,3.57,0,0,1-.52-1.25,7.69,7.69,0,0,1-.17-1.68,7.83,7.83,0,0,1,.17-1.68,3.65,3.65,0,0,1,.52-1.25,2.44,2.44,0,0,1,.89-.77,2.84,2.84,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.23,5.23,0,0,1,.7,2.93,5.23,5.23,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.63,22.13Zm0-1.22a1.07,1.07,0,0,0,1-.55A3.38,3.38,0,0,0,21,18.85V17.47a3.31,3.31,0,0,0-.29-1.5,1.23,1.23,0,0,0-2.06,0,3.31,3.31,0,0,0-.29,1.5v1.38a3.38,3.38,0,0,0,.29,1.51A1.06,1.06,0,0,0,19.63,20.91Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M10.63,22V20.82h2V15.63l-1.86,1-.55-1.06,2.32-1.3H14v6.5h1.78V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rewind_10.propTypes = iconPropTypes;
}
const Rewind_30 = /*#__PURE__*/React.forwardRef(function Rewind_30({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64,22.13a2.81,2.81,0,0,1-1.28-.27,2.36,2.36,0,0,1-.89-.77A3.39,3.39,0,0,1,17,19.84a7.12,7.12,0,0,1-.17-1.68A7.24,7.24,0,0,1,17,16.48a3.46,3.46,0,0,1,.52-1.25,2.36,2.36,0,0,1,.89-.77,2.81,2.81,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.31,5.31,0,0,1,.7,2.93,5.31,5.31,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.64,22.13Zm0-1.22a1,1,0,0,0,1-.55,3.24,3.24,0,0,0,.3-1.51V17.47a3.17,3.17,0,0,0-.3-1.5,1.22,1.22,0,0,0-2.05,0,3.18,3.18,0,0,0-.29,1.5v1.38a3.25,3.25,0,0,0,.29,1.51A1,1,0,0,0,19.64,20.91Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M12.62,17.42a1.46,1.46,0,0,0,1-.27.84.84,0,0,0,.31-.68v-.08a.94.94,0,0,0-.3-.74,1.2,1.2,0,0,0-.83-.27,1.65,1.65,0,0,0-.89.24,2.1,2.1,0,0,0-.68.68l-.93-.83a5.37,5.37,0,0,1,.44-.51,2.7,2.7,0,0,1,.54-.4,2.55,2.55,0,0,1,.7-.27,3.25,3.25,0,0,1,.87-.1,3.94,3.94,0,0,1,1.06.14,2.33,2.33,0,0,1,.82.4,1.91,1.91,0,0,1,.54.63,1.87,1.87,0,0,1,.18.83,2,2,0,0,1-.11.67,1.82,1.82,0,0,1-.32.52,1.79,1.79,0,0,1-.47.36,2.27,2.27,0,0,1-.57.2V18a2.34,2.34,0,0,1,.63.21,1.7,1.7,0,0,1,.51.38,1.89,1.89,0,0,1,.34.55,2.07,2.07,0,0,1,.12.73,2,2,0,0,1-.2.92,2,2,0,0,1-.58.72,2.66,2.66,0,0,1-.89.45,3.76,3.76,0,0,1-1.15.16,4.1,4.1,0,0,1-1-.11A3.1,3.1,0,0,1,11,21.7a2.76,2.76,0,0,1-.56-.45A4.22,4.22,0,0,1,10,20.7l1.07-.81a3.07,3.07,0,0,0,.28.42,1.94,1.94,0,0,0,.36.34,1.57,1.57,0,0,0,.45.22,2,2,0,0,0,.57.07,1.45,1.45,0,0,0,1-.3,1.12,1.12,0,0,0,.34-.85v-.08a1,1,0,0,0-.37-.8,1.78,1.78,0,0,0-1.06-.28h-.76V17.42Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rewind_30.propTypes = iconPropTypes;
}
const Rewind_5 = /*#__PURE__*/React.forwardRef(function Rewind_5({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rewind_5.propTypes = iconPropTypes;
}
const RightPanelClose = /*#__PURE__*/React.forwardRef(function RightPanelClose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm20,0h6v20h-6V6Zm-18,0h16v20H4v-9h10.1699s-3.5801,3.5898-3.5801,3.5898l1.4102,1.4102,6-6-6-6-1.4102,1.4102,3.5801,3.5898H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RightPanelClose.propTypes = iconPropTypes;
}
const RightPanelCloseFilled = /*#__PURE__*/React.forwardRef(function RightPanelCloseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm2,0h16v20H4v-9h10.1699s-3.5801,3.5898-3.5801,3.5898l1.4102,1.4102,6-6-6-6-1.4102,1.4102,3.5801,3.5898H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RightPanelCloseFilled.propTypes = iconPropTypes;
}
const RightPanelOpen = /*#__PURE__*/React.forwardRef(function RightPanelOpen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm20,0h6v20h-6V6Zm-18,0h16v9h-10.1699s3.5798-3.5898,3.5798-3.5898l-1.4099-1.4102-6,6,6,6,1.4099-1.4102-3.5798-3.5898h10.1699v9H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RightPanelOpen.propTypes = iconPropTypes;
}
const RightPanelOpenFilled = /*#__PURE__*/React.forwardRef(function RightPanelOpenFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm2,0h16v9h-10.1699s3.5798-3.5898,3.5798-3.5898l-1.4099-1.4102-6,6,6,6,1.4099-1.4102-3.5798-3.5898h10.1699v9H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RightPanelOpenFilled.propTypes = iconPropTypes;
}
const Road = /*#__PURE__*/React.forwardRef(function Road({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H19V15H13z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4409,8,24.1687,3.45A2.009,2.009,0,0,0,22.2456,2H9.7544A2.0089,2.0089,0,0,0,7.8313,3.4507L6.5315,8H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V19H22v3h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM9.7544,4H22.2458l1.4285,5H8.3257ZM24,13H22v2h2v2H8V15h2V13H8V11H24Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H4V30H2z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H30V30H28z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H17V24H15z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Road.propTypes = iconPropTypes;
}
const RoadWeather = /*#__PURE__*/React.forwardRef(function RoadWeather({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31H14v-.228a3.0135,3.0135,0,0,0-1.9468-2.8091L8.5215,26.6384A3.9034,3.9034,0,0,1,6,23H8a1.8946,1.8946,0,0,0,1.2236,1.7659L12.7554,26.09A5.0226,5.0226,0,0,1,16,30.772Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M30,31H28v-.228a3.0135,3.0135,0,0,0-1.9468-2.8091l-3.5317-1.3245A3.9034,3.9034,0,0,1,20,23h2a1.8946,1.8946,0,0,0,1.2236,1.7659L26.7554,26.09A5.0226,5.0226,0,0,1,30,30.772Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H17V15H11z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RoadWeather.propTypes = iconPropTypes;
}
const Roadmap = /*#__PURE__*/React.forwardRef(function Roadmap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0023,2.0023,0,0,1-2-2V24a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,12,30ZM4,24v4h8V24Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H12a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,20ZM12,14v4H28V14Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10H4A2.0023,2.0023,0,0,1,2,8V4A2.0023,2.0023,0,0,1,4,2H16a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,16,10ZM4,4V8H16V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Roadmap.propTypes = iconPropTypes;
}
const Rocket = /*#__PURE__*/React.forwardRef(function Rocket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34 19H17.65V21H6.34z",
    transform: "rotate(-45 11.995 20.002)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rocket.propTypes = iconPropTypes;
}
const Rotate = /*#__PURE__*/React.forwardRef(function Rotate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M17.91,26.82l.35,2a12.9,12.9,0,0,0,4.24-1.54l-1-1.73A10.88,10.88,0,0,1,17.91,26.82Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M24.42,23.07,26,24.35a13,13,0,0,0,2.24-3.91l-1.87-.68A11,11,0,0,1,24.42,23.07Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,27.25a12.9,12.9,0,0,0,4.24,1.54l.35-2a10.88,10.88,0,0,1-3.59-1.3Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67,19.76l-1.87.68A13,13,0,0,0,6,24.35l.32-.26,1.22-1h0a11,11,0,0,1-1.91-3.31Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M29,16a12.85,12.85,0,0,0-.8-4.44l-1.87.68A11.18,11.18,0,0,1,27,16Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7.65a13,13,0,0,0-20,0V4H4v8h8V10H6.81A11,11,0,0,1,24.42,8.93Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rotate.propTypes = iconPropTypes;
}
const WatsonHealthRotate_180 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_180({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0913,26.8235l-.3467,1.968a12.8956,12.8956,0,0,1-4.24-1.5418l1-1.7307A10.9086,10.9086,0,0,0,14.0913,26.8235Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5767,23.0682,6.0449,24.3533a12.9811,12.9811,0,0,1-2.25-3.9112l1.8775-.6834A10.9808,10.9808,0,0,0,7.5767,23.0682Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4951,27.25a12.8956,12.8956,0,0,1-4.24,1.5418l-.3467-1.968a10.9086,10.9086,0,0,0,3.5869-1.3045Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3271,19.7587l1.8775.6834a12.9811,12.9811,0,0,1-2.2495,3.9112l-.3115-.2614-1.22-1.0237h0a10.9822,10.9822,0,0,0,1.9038-3.3093Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6616,5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438,10.9438,0,0,0,5,16H3A12.9363,12.9363,0,0,1,6.05,7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331,12.9331,0,0,1,26,7.7031V4h2v8H20V10h5.1885A10.961,10.961,0,0,0,16,5a11.1114,11.1114,0,0,0-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575,5.165,13.907,5.2026,13.6616,5.2559Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthRotate_180.propTypes = iconPropTypes;
}
const WatsonHealthRotate_360 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_360({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthRotate_360.propTypes = iconPropTypes;
}
const RotateClockwise = /*#__PURE__*/React.forwardRef(function RotateClockwise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H16a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM16,16V28H28.0012L28,16Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M15,2,13.59,3.41,16.17,6H11a7.0078,7.0078,0,0,0-7,7v5H6V13a5.0057,5.0057,0,0,1,5-5h5.17l-2.58,2.59L15,12l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateClockwise.propTypes = iconPropTypes;
}
const RotateClockwiseAlt = /*#__PURE__*/React.forwardRef(function RotateClockwiseAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,16,30ZM4,16V28H16.0012L16,16Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15l-1.41-1.41L26,16.17V11a7.0078,7.0078,0,0,0-7-7H14V6h5a5.0057,5.0057,0,0,1,5,5v5.17l-2.59-2.58L20,15l5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateClockwiseAlt.propTypes = iconPropTypes;
}
const RotateClockwiseAltFilled = /*#__PURE__*/React.forwardRef(function RotateClockwiseAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,16,30Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15l-1.41-1.41L26,16.17V11a7.0078,7.0078,0,0,0-7-7H14V6h5a5.0057,5.0057,0,0,1,5,5v5.17l-2.59-2.58L20,15l5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateClockwiseAltFilled.propTypes = iconPropTypes;
}
const RotateClockwiseFilled = /*#__PURE__*/React.forwardRef(function RotateClockwiseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H16a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M15,2,13.59,3.41,16.17,6H11a7.0078,7.0078,0,0,0-7,7v5H6V13a5.0057,5.0057,0,0,1,5-5h5.17l-2.58,2.59L15,12l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateClockwiseFilled.propTypes = iconPropTypes;
}
const RotateCounterclockwise = /*#__PURE__*/React.forwardRef(function RotateCounterclockwise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M2,28V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,28ZM4,16,3.9988,28H16V16Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2l1.41,1.41L15.83,6H21a7.0078,7.0078,0,0,1,7,7v5H26V13a5.0057,5.0057,0,0,0-5-5H15.83l2.58,2.59L17,12,12,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateCounterclockwise.propTypes = iconPropTypes;
}
const RotateCounterclockwiseAlt = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H16A2.0023,2.0023,0,0,1,14,28Zm2-12-.0012,12H28V16Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M2,15l1.41-1.41L6,16.17V11a7.0078,7.0078,0,0,1,7-7h5V6H13a5.0057,5.0057,0,0,0-5,5v5.17l2.59-2.58L12,15,7,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateCounterclockwiseAlt.propTypes = iconPropTypes;
}
const RotateCounterclockwiseAltFilled = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H16A2.0023,2.0023,0,0,1,14,28Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M2,15l1.41-1.41L6,16.17V11a7.0078,7.0078,0,0,1,7-7h5V6H13a5.0057,5.0057,0,0,0-5,5v5.17l2.59-2.58L12,15,7,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateCounterclockwiseAltFilled.propTypes = iconPropTypes;
}
const RotateCounterclockwiseFilled = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M2,28V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,28Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2l1.41,1.41L15.83,6H21a7.0078,7.0078,0,0,1,7,7v5H26V13a5.0057,5.0057,0,0,0-5-5H15.83l2.58,2.59L17,12,12,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RotateCounterclockwiseFilled.propTypes = iconPropTypes;
}
const Router = /*#__PURE__*/React.forwardRef(function Router({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Router.propTypes = iconPropTypes;
}
const RouterVoice = /*#__PURE__*/React.forwardRef(function RouterVoice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4289,5.8227v1.63a1.1269,1.1269,0,0,1-.6767,1.026l-1.39.5967A1.1218,1.1218,0,0,1,9.14,8.8424L7.3208,7.0233a1.1165,1.1165,0,0,1,.0125-1.579l.0348-.0328c7.393-6.527,14.6913-2.0374,17.2127-.0473a1.1166,1.1166,0,0,1,.1746,1.5693,1.1011,1.1011,0,0,1-.0873.0971L22.9108,8.7878a1.1114,1.1114,0,0,1-1.2225.2329l-1.39-.5967a1.1112,1.1112,0,0,1-.68-1.0223v-1.63S15.9726,3.0648,12.4289,5.8227Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RouterVoice.propTypes = iconPropTypes;
}
const RouterWifi = /*#__PURE__*/React.forwardRef(function RouterWifi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13.5",
    r: "1.5"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0713,6.929a10,10,0,0,0-14.1426,0L7.5146,5.5144a12.0011,12.0011,0,0,1,16.9708,0Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RouterWifi.propTypes = iconPropTypes;
}
const Row = /*#__PURE__*/React.forwardRef(function Row({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H28V26H4z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H6V14H26v4m2,0V14a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H28V8H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Row.propTypes = iconPropTypes;
}
const RowCollapse = /*#__PURE__*/React.forwardRef(function RowCollapse({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V22A2,2,0,0,0,26,20Zm0,6H6V22H26Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RowCollapse.propTypes = iconPropTypes;
}
const RowDelete = /*#__PURE__*/React.forwardRef(function RowDelete({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,24,30ZM4,22H3.9985L4,28H24V22Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RowDelete.propTypes = iconPropTypes;
}
const RowExpand = /*#__PURE__*/React.forwardRef(function RowExpand({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,6H6V6H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RowExpand.propTypes = iconPropTypes;
}
const RowInsert = /*#__PURE__*/React.forwardRef(function RowInsert({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H10a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12ZM10,4v6H28V4Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H10a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM10,22v6H28V22Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RowInsert.propTypes = iconPropTypes;
}
const Rss = /*#__PURE__*/React.forwardRef(function Rss({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M8,18c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6C14,20.7,11.3,18,8,18z M8,28c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4 C12,26.2,10.2,28,8,28z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24h-2C28,13,19,4,8,4V2C20.1,2,30,11.9,30,24z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rss.propTypes = iconPropTypes;
}
const Rule = /*#__PURE__*/React.forwardRef(function Rule({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H22V12H10z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Rule.propTypes = iconPropTypes;
}
const RuleCancelled = /*#__PURE__*/React.forwardRef(function RuleCancelled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RuleCancelled.propTypes = iconPropTypes;
}
const RuleDataQuality = /*#__PURE__*/React.forwardRef(function RuleDataQuality({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-2.8-2.8C27.7,25,28,24,28,23c0-2.8-2.2-5-5-5s-5,2.2-5,5s2.2,5,5,5c1,0,2-0.3,2.8-0.8l2.8,2.8 L30,28.6z M20,23c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3S20,24.7,20,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  RuleDataQuality.propTypes = iconPropTypes;
}
const RuleDraft = /*#__PURE__*/React.forwardRef(function RuleDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RuleDraft.propTypes = iconPropTypes;
}
const RuleFilled = /*#__PURE__*/React.forwardRef(function RuleFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 16H23V18H9z",
    "data-icon-path": "inner-path"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 10H23V12H9z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RuleFilled.propTypes = iconPropTypes;
}
const RuleLocked = /*#__PURE__*/React.forwardRef(function RuleLocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22v-3c0-2.2-1.8-4-4-4s-4,1.8-4,4v3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2v-5C30,22.9,29.1,22,28,22z M22,19c0-1.1,0.9-2,2-2s2,0.9,2,2v3h-4V19z M20,29v-5h8v5H20z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v8h2V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RuleLocked.propTypes = iconPropTypes;
}
const RulePartial = /*#__PURE__*/React.forwardRef(function RulePartial({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S26.9,16,23,16z M23,28V18c2.8,0,5,2.2,5,5S25.8,28,23,28z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v9h2V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RulePartial.propTypes = iconPropTypes;
}
const RuleTest = /*#__PURE__*/React.forwardRef(function RuleTest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RuleTest.propTypes = iconPropTypes;
}
const Ruler = /*#__PURE__*/React.forwardRef(function Ruler({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ruler.propTypes = iconPropTypes;
}
const RulerAlt = /*#__PURE__*/React.forwardRef(function RulerAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RulerAlt.propTypes = iconPropTypes;
}
const Run = /*#__PURE__*/React.forwardRef(function Run({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19L19 25 24 22 19 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Run.propTypes = iconPropTypes;
}
const RunMirror = /*#__PURE__*/React.forwardRef(function RunMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19L9 25 14 22z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14 L11,14z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  RunMirror.propTypes = iconPropTypes;
}
const Running = /*#__PURE__*/React.forwardRef(function Running({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m21.707,20.293l-5-5c-.1951-.1953-.451-.293-.707-.293s-.512.0977-.707.293L2,28.5859l1.4143,1.4141,12.5857-12.5859,3.5857,3.5859-5.5857,5.5859,1.4143,1.4141,2.292-2.292,4.0007-4.001c.1953-.1953.293-.4512.293-.707s-.0977-.5117-.293-.707Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5859,9l-5.5859,5.5859-6.0012-6.0015c-.392-.3918-.9073-.5865-1.422-.5845-.5096.002-1.0185.1968-1.4063.5845l-6.1704,6.1753,1.4143,1.4141,6.1704-6.1748,6.7083,6.708c.1951.1953.4512.293.707.293s.512-.0977.707-.293l6.293-6.293-1.4141-1.4141Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5,9c-1.9299,0-3.5-1.5701-3.5-3.5s1.5701-3.5,3.5-3.5,3.5,1.5701,3.5,3.5-1.5701,3.5-3.5,3.5Zm0-5c-.8271,0-1.5.6729-1.5,1.5s.6729,1.5,1.5,1.5,1.5-.6729,1.5-1.5-.6729-1.5-1.5-1.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Running.propTypes = iconPropTypes;
}
const QS = /*#__PURE__*/React.forwardRef(function QS({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QS.propTypes = iconPropTypes;
}
const QSAlt = /*#__PURE__*/React.forwardRef(function QSAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H8V21h6V17H10a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H10v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,14,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QSAlt.propTypes = iconPropTypes;
}
const SailboatCoastal = /*#__PURE__*/React.forwardRef(function SailboatCoastal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SailboatCoastal.propTypes = iconPropTypes;
}
const SailboatOffshore = /*#__PURE__*/React.forwardRef(function SailboatOffshore({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SailboatOffshore.propTypes = iconPropTypes;
}
const SalesOps = /*#__PURE__*/React.forwardRef(function SalesOps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "m30,6v-2h-3v-2h-2v2h-1c-1.1028,0-2,.8975-2,2v2c0,1.1025.8972,2,2,2h4v2h-6v2h3v2h2v-2h1c1.1028,0,2-.8975,2-2v-2c0-1.1025-.8972-2-2-2h-4v-2h6Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "m24,20v2h2.5859l-3.5857,3.5859-2.2917-2.293c-.1875-.1875-.4419-.293-.707-.293h-.0015c-.2651,0-.5183.1055-.7058.293l-5.2942,5.293,1.4143,1.4141,4.5867-4.5859,2.2917,2.293c.1875.1875.4419.293.7073.293.2651,0,.5195-.1055.707-.293l4.293-4.293v2.5859h2v-6h-6Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m4,30h-2v-5c0-3.8599,3.1401-7,7-7h6c1.9885,0,3.8901.8502,5.217,2.3328l-1.4902,1.334c-.948-1.0592-2.3064-1.6667-3.7268-1.6667h-6c-2.7571,0-5,2.243-5,5v5Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m12,16c3.866,0,7-3.134,7-7s-3.134-7-7-7-7,3.134-7,7,3.134,7,7,7Zm0-12c2.7615,0,5,2.2385,5,5s-2.2385,5-5,5-5-2.2385-5-5c.0032-2.7601,2.2399-4.9968,5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SalesOps.propTypes = iconPropTypes;
}
const SankeyDiagram = /*#__PURE__*/React.forwardRef(function SankeyDiagram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SankeyDiagram.propTypes = iconPropTypes;
}
const SankeyDiagramAlt = /*#__PURE__*/React.forwardRef(function SankeyDiagramAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SankeyDiagramAlt.propTypes = iconPropTypes;
}
const Satellite = /*#__PURE__*/React.forwardRef(function Satellite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Satellite.propTypes = iconPropTypes;
}
const SatelliteRadar = /*#__PURE__*/React.forwardRef(function SatelliteRadar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H24a6.0067,6.0067,0,0,0-6-6V6A8.0092,8.0092,0,0,1,26,14Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28V24.96a9.9124,9.9124,0,0,0,7.3179-2.208,1.8482,1.8482,0,0,0,.6777-1.3344,1.8,1.8,0,0,0-.5239-1.36L18.4141,15,21,12.4141,19.5859,11,17,13.5859,11.9419,8.5273a1.8145,1.8145,0,0,0-1.36-.5229,1.845,1.845,0,0,0-1.3339.6782,9.9566,9.9566,0,0,0-.5127,11.95L6.2793,28H2v2H30V28ZM10.68,10.0938,21.9058,21.32A8.0011,8.0011,0,0,1,10.68,10.0938ZM14,28H8.3875l1.8757-5.627A9.9894,9.9894,0,0,0,14,24.5435Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SatelliteRadar.propTypes = iconPropTypes;
}
const SatelliteWeather = /*#__PURE__*/React.forwardRef(function SatelliteWeather({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,12H19a4,4,0,0,1,0-8h.0835A4.7864,4.7864,0,0,1,23,2a4.9816,4.9816,0,0,1,4.6543,3.2034A3.4667,3.4667,0,0,1,30,8.5,3.5041,3.5041,0,0,1,26.5,12ZM19,6a2,2,0,0,0,0,4h7.5A1.5017,1.5017,0,0,0,28,8.5a1.4855,1.4855,0,0,0-1.2778-1.4739L26.061,6.927l-.1616-.6487a2.9568,2.9568,0,0,0-5.4873-.7121L20.1143,6Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M13,28V24.8882a7.9363,7.9363,0,0,0,4.707-2.2818.9995.9995,0,0,0,0-1.414L13.4644,16.95,16,14.4141,14.5859,13,12.05,15.5356,7.8076,11.293a.9994.9994,0,0,0-1.414,0,7.9993,7.9993,0,0,0,0,11.3134c.1621.1622.3327.3125.5058.459L4.4321,28H2v2H30V28Zm-2,0H6.6685L8.59,24.1567A7.8927,7.8927,0,0,0,11,24.873ZM7.8076,21.1924a6.0036,6.0036,0,0,1-.6489-7.72l8.3686,8.3681a6.0026,6.0026,0,0,1-7.72-.6484Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SatelliteWeather.propTypes = iconPropTypes;
}
const SatisfyDefinition = /*#__PURE__*/React.forwardRef(function SatisfyDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.3945,19.5537c0-1.8433,1.3953-2.7563,3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337,0-1.6194.5168-2.05,1.137l-1.3093-1.1714c.6545-1.0337,1.7056-1.7228,3.5144-1.7228,2.429,0,3.7209,1.1543,3.7209,3.2042v4.2379h.896v1.7572h-1.2231c-.9475,0-1.5332-.6201-1.6711-1.5504h-.1033c-.293,1.1542-1.2749,1.7572-2.6187,1.7572-1.8259,0-2.8596-1.0509-2.8596-2.6531Zm5.3624-.2412v-1.1886h-1.4126c-1.1541,0-1.7227.3962-1.7227,1.1025v.2928c0,.7235.4995,1.0853,1.3608,1.0853.9819,0,1.7744-.4479,1.7744-1.2921Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m6.6195,20.2084l1.5332-1.4816c.8269.9647,1.8433,1.4816,3.0837,1.4816,1.3953,0,2.1189-.6719,2.1189-1.6882,0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971,0-2.1534,1.6709-3.5488,4.3584-3.5488,1.8088,0,3.1526.6202,4.1172,1.7744l-1.5503,1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292,0-1.9639.5168-1.9639,1.4126,0,.9131.5168,1.292,1.6711,1.4988l1.1196.2067c2.429.4308,3.5662,1.516,3.5662,3.4972,0,2.2739-1.6367,3.8245-4.5137,3.8245-2.05,0-3.4626-.8097-4.479-1.9984Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SatisfyDefinition.propTypes = iconPropTypes;
}

export { Purchase, QS, QSAlt, Qiskit, QqPlot, QrCode, QuadrantPlot, Query, QueryQueue, QuestionAnswering, Queued, Quotes, Radar, RadarEnhanced, RadarWeather, Radio, RadioButton, RadioButtonChecked, RadioCombat, RadioPushToTalk, Rag, Rain, RainDrizzle, RainDrop, RainHeavy, RainScattered, RainScatteredNight, Raw, Receipt, RecentlyViewed, Recommend, Recording, RecordingFilled, RecordingFilledAlt, Recycle, Redefinition, Redo, RefEvapotranspiration, ReferenceArchitecture, ReflectHorizontal, ReflectVertical, Reminder, ReminderMedical, Renew, Repeat, RepeatOne, Replicate, Reply, ReplyAll, RepoArtifact, RepoSourceCode, Report, ReportData, RequestQuote, RequirementDefinition, RequirementUsage, Reset, ResetAlt, Restart, Restaurant, RestaurantFine, Result, ResultDraft, ResultNew, ResultOld, RetryFailed, Return, Review, Rewind_10, Rewind_30, Rewind_5, RightPanelClose, RightPanelCloseFilled, RightPanelOpen, RightPanelOpenFilled, Road, RoadWeather, Roadmap, Rocket, Rotate, RotateClockwise, RotateClockwiseAlt, RotateClockwiseAltFilled, RotateClockwiseFilled, RotateCounterclockwise, RotateCounterclockwiseAlt, RotateCounterclockwiseAltFilled, RotateCounterclockwiseFilled, Router, RouterVoice, RouterWifi, Row, RowCollapse, RowDelete, RowExpand, RowInsert, Rss, Rule, RuleCancelled, RuleDataQuality, RuleDraft, RuleFilled, RuleLocked, RulePartial, RuleTest, Ruler, RulerAlt, Run, RunMirror, Running, SailboatCoastal, SailboatOffshore, SalesOps, SankeyDiagram, SankeyDiagramAlt, Satellite, SatelliteRadar, SatelliteWeather, SatisfyDefinition, WatsonHealthQcLaunch, WatsonHealthRegionAnalysisArea, WatsonHealthRegionAnalysisVolume, WatsonHealthRegistration, WatsonHealthRotate_180, WatsonHealthRotate_360 };
